import React from 'react';

// Msg #986 — Composer extracted from ChatPage.jsx to reduce that file's size.
// Renders the chat input row + style/color compose toolbar.
export default function Composer({
  input, setInput,
  onSend,               // () => void — called on Enter / SEND click
  onTyping,             // () => void — WS "user is typing" ping
  myColor, setMyColor,
  composeMode, setComposeMode,
  systemColor = '#5a3a8a',
}) {
  return (
    <>
      <div className="mt-3 flex items-center gap-2 mobile-say-row">
        <span className="text-[12px]" style={{ color: systemColor }}>Say:</span>
        <input
          data-testid="chat-input"
          className="chat-input"
          value={input}
          onChange={(e) => {
            setInput(e.target.value);
            if (e.target.value && onTyping) onTyping();
          }}
          onKeyDown={(e) => e.key === 'Enter' && onSend()}
          placeholder="Type your message... commands start with /  (try /me, /roll 2d6, /whisper, /clear, /color FF0000)"
          style={{ color: myColor }}
        />
        <button data-testid="chat-send-btn" className="keep-btn" onClick={onSend}>SEND</button>
      </div>

      {/* Session AD (Msg #972) — compose style + font color picker */}
      <div
        data-testid="compose-toolbar"
        className="mt-2 flex flex-wrap items-center gap-3"
        style={{
          padding: '6px 10px',
          border: '1px solid var(--room-border, #c8c8b8)',
          background: 'var(--room-bg, #fafaf7)',
          fontSize: 12,
          color: 'var(--room-text, #2a2a1a)',
        }}
      >
        <div style={{ display: 'flex', alignItems: 'center', gap: 8 }}>
          <span style={{ fontWeight: 'bold', letterSpacing: 1 }}>STYLE:</span>
          {[
            ['say',    'Say',       'Plain speech'],
            ['action', ': Action',  'Wraps as an action line (like /me)'],
            ['ooc',    '(( OOC ))', 'Wraps text in double parentheses'],
          ].map(([mode, label, tip]) => (
            <label
              key={mode}
              title={tip}
              data-testid={`compose-style-${mode}`}
              style={{
                cursor: 'pointer', padding: '2px 8px',
                border: '1px solid var(--room-border, #c8c8b8)',
                background: composeMode === mode ? '#4a4a4a' : 'var(--room-panel, #f5f5f0)',
                color: composeMode === mode ? '#f5f5f0' : 'var(--room-text, #2a2a1a)',
                fontWeight: composeMode === mode ? 'bold' : 'normal',
              }}
            >
              <input
                type="radio"
                name="compose-mode"
                checked={composeMode === mode}
                onChange={() => setComposeMode(mode)}
                style={{ display: 'none' }}
              />
              {label}
            </label>
          ))}
        </div>

        <div style={{ display: 'flex', alignItems: 'center', gap: 6, flexWrap: 'wrap' }}>
          <span style={{ fontWeight: 'bold', letterSpacing: 1 }}>COLOR:</span>
          {[
            '#111111','#7a1f1f','#a04040','#a06020','#a08a20','#4a7a20',
            '#207a4a','#20707a','#204a7a','#4a207a','#7a2070','#7a3a3a',
          ].map((c) => (
            <button
              key={c}
              data-testid={`color-swatch-${c.replace('#','')}`}
              onClick={() => setMyColor(c)}
              title={c}
              style={{
                width: 18, height: 18, background: c,
                border: myColor.toLowerCase() === c ? '2px solid #000' : '1px solid #888',
                cursor: 'pointer', padding: 0,
              }}
            />
          ))}
          <input
            data-testid="color-hex-input"
            type="text"
            value={myColor}
            onChange={(e) => {
              const v = e.target.value.trim();
              if (/^#[0-9a-fA-F]{3}$/.test(v) || /^#[0-9a-fA-F]{6}$/.test(v)) setMyColor(v);
              else if (/^[0-9a-fA-F]{6}$/.test(v)) setMyColor('#' + v);
            }}
            style={{
              width: 76, fontSize: 11, padding: '1px 4px',
              border: '1px solid var(--room-border, #c8c8b8)',
              background: 'var(--room-panel, #fff)',
              color: 'var(--room-text, #2a2a1a)',
              fontFamily: 'monospace',
            }}
            placeholder="#RRGGBB"
          />
          {/* Msg #988 — Native color-wheel picker (OS picker). */}
          <label
            data-testid="color-wheel-label"
            title="Open OS color wheel picker"
            style={{
              display: 'inline-flex', alignItems: 'center', gap: 4,
              cursor: 'pointer',
              padding: '1px 6px',
              border: '1px solid var(--room-border, #c8c8b8)',
              background: 'linear-gradient(45deg,#ff004d,#ffbe0b,#8ac926,#1982c4,#6a4c93,#ff004d)',
              color: '#fff', fontWeight: 'bold', fontSize: 11,
              textShadow: '0 0 2px rgba(0,0,0,0.9)',
            }}
          >
            🎨
            <input
              data-testid="color-wheel-input"
              type="color"
              value={/^#[0-9a-fA-F]{6}$/.test(myColor) ? myColor : '#111111'}
              onChange={(e) => setMyColor(e.target.value.toLowerCase())}
              style={{
                width: 0, height: 0, padding: 0, border: 0,
                opacity: 0, position: 'absolute',
              }}
            />
          </label>
          <span
            data-testid="color-preview"
            style={{
              color: myColor, fontWeight: 'bold',
              padding: '0 6px', textShadow: '0 0 1px #999',
            }}
          >Preview</span>
        </div>
      </div>
    </>
  );
}
